import {useContext} from "react";

import {SharedStatusPageFormKeys} from "@/pages/statuspages/shared/StatusPage.types.ts";
import {StatusPageContext} from "@/pages/statuspages/statuspages-manage/ManageStatusPageTabContainer.utils.tsx";
import {ManageStatusPageUpdateFormTab} from "@/pages/statuspages/statuspages-manage/ManageStatusPageUpdateFormTab.tsx";
import {StatusPageDesignTabDefaultValues} from "@/pages/statuspages/tabs/design/StatusPageDesignTab.form.ts";
import {StatusPageDesignTabV2} from "@/pages/statuspages/tabs/design/StatusPageDesignTabV2.tsx";

export const StatusPageManageDesignTabWrapper = () => {
  const {statusPage} = useContext(StatusPageContext);

  return (
    <ManageStatusPageUpdateFormTab
      key={"design"}
      fields={Object.keys(StatusPageDesignTabDefaultValues) as SharedStatusPageFormKeys[]}
    >
      <StatusPageDesignTabV2 default_theme={statusPage.theme} />
    </ManageStatusPageUpdateFormTab>
  );
};
